<div class="dialog-header">
  <h3>
    <ng-container>{{ "edit-completion-prediction" | translate }}</ng-container>
  </h3>
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog(false)"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>

<div class="dialog-content">
  <form [formGroup]="form">
    <div class="row-fx-legacy">
      <mat-form-field>
        <mat-label>{{ "input-completion-prediction" | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="previsionDatePicker"
          formControlName="previsionDate"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="previsionDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #previsionDatePicker></mat-datepicker>
        <mat-error
          *ngIf="
            form.get('previsionDate').touched &&
            form.get('previsionDate').hasError('required')
          "
          >{{ "required-completion-prediction" | translate }}</mat-error
        >
      </mat-form-field>

      <mat-form-field class="mat-form-field-margin">
        <mat-label>{{ "label-period" | translate }}</mat-label>
        <mat-select formControlName="period">
          <mat-option *ngFor="let period of periods" [value]="period.value">
            {{ period.name | uppercase }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            form.get('period').touched &&
            form.get('period').hasError('required')
          "
          >{{ "find-carworkshop-maps.required-field" | translate }}</mat-error
        >
      </mat-form-field>
    </div>
  </form>
</div>

<div class="dialog-actions">
  <button
    [disabled]="form.invalid"
    mat-raised-button
    color="primary"
    (click)="closeDialog(true)"
  >
    {{ "input-save" | translate }}
  </button>
  <button mat-button (click)="closeDialog(false)">
    {{ "input-cancel" | translate }}
  </button>
</div>
